export const fakeData = [
    {
        id: 1,
        img: 'https://via.placeholder.com/150', 
        name: 'Ian Dancan',
        profession: 'Founder & CEO, KilonzoCorp',
        message: "KilonzoCorp’s data annotation services have drastically improved the precision and efficiency of our AI models. Their team is professional and highly skilled, delivering exceptional results every time."
    },
    {
        id: 2,
        img: 'https://via.placeholder.com/150', 
        name: 'Nelson Tommogo',
        profession: 'CEO, MEBIUT',
        message: "KilonzoCorp helped us build a robust data infrastructure, enabling better insights and faster decision-making. Their team’s expertise in data management is invaluable."
    },
    {
        id: 3,
        img: 'https://via.placeholder.com/150',
        name: 'Lavendar Akinyi',
        profession: 'Senior UI/UX Designer',
        message: "Thanks to KilonzoCorp, our AI models are more accurate than ever. Their data-driven solutions are top-notch and have significantly enhanced our platform’s performance."
    },
    {
        id: 4,
        img: 'https://via.placeholder.com/150', 
        name: 'Alan Wekesa',
        profession: 'Software Engineer, One Health',
        message: "KilonzoCorp’s expertise in tech and data analytics helped us develop a secure, efficient platform for delivering healthcare services."
    },
    {
        id: 5,
        img: 'https://via.placeholder.com/150',
        name: 'Tony Wekesa',
        profession: 'Economist & Data Analyst',
        message: "The insights we gained from KilonzoCorp’s data analytics services have reshaped our approach to understanding market trends and customer behaviors."
    },
    {
        id: 6,
        img: 'https://via.placeholder.com/150',
        name: 'Musa Mona',
        profession: 'Tech Entrepreneur',
        message: "KilonzoCorp has been a key partner in our journey to digital transformation. Their innovative solutions and commitment to excellence are unmatched."
    },
];
